export const NEWS_BAR_SECTION = "GE2025";
export const NEWS_BAR_SECTION_URL = "/keywords/ge2025";
